document.addEventListener("DOMContentLoaded", function() {
  const stickyLetters = document.getElementById("letters");
  const stickyHeader = document.getElementsByTagName("sticky-header")[0];


  if (stickyLetters) {
    const stickyHeightLetters = stickyLetters.offsetHeight;
    const stickyHeightHeader = stickyHeader.offsetHeight;
    const stickyHeight = stickyHeightLetters+stickyHeightHeader

    // Vous pouvez utiliser stickyHeight dans votre logique de défilement personnalisé
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - stickyHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
});
